import styled from 'styled-components';
import { placeholderImages, PlaceholderType } from './BgPlaceholder.model';

const BgPlaceholder = styled.div<{ $type: PlaceholderType }>`
	position: absolute;
	width: 100%;
	height: 100%;
	background-image: url(${(props) => placeholderImages[props.$type]});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 50% 50%;
`;

export { BgPlaceholder };
